import { render, staticRenderFns } from "./NavigationMenu.vue?vue&type=template&id=6fc0b4ac&scoped=true"
import script from "./NavigationMenu.vue?vue&type=script&lang=ts"
export * from "./NavigationMenu.vue?vue&type=script&lang=ts"
import style0 from "./NavigationMenu.vue?vue&type=style&index=0&id=6fc0b4ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc0b4ac",
  null
  
)

/* custom blocks */
import block0 from "./NavigationMenu.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports